import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { MSpinner } from "components/Shared";
import QaRejectionList from "components/Homeowner/Appraisal/QaRejectionList";
import QaRejectionRespond from "components/Homeowner/Appraisal/QaRejectionRespond";
import { cloneDeep } from "lodash";
import { getAppraisalQARejections, resolveAppraisalQARejection } from "requests/homeowner/caseforms";

export default function QaRejectionsWithResponse(props) {

  const [appraisalQaRejections, setAppraisalQaRejections] = useState(null);
  const [currentRejection, setCurrentRejection] = useState(null);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  let mounted = useRef(true);

  const getRejections = () => {
    getAppraisalQARejections(props.controlNumber, setAppraisalQaRejections, setIsFetching, mounted);
  };

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    getRejections();
  }, [props.controlNumber]);

  const onRejectionSelected = (rejection) => {
    setCurrentRejection(cloneDeep(rejection));
    setDialogVisible(true);
  };

  const respondToRejection = (rejection) => {
    resolveAppraisalQARejection(rejection, rejection.responseNotes, () => {
      getRejections();
      props.onQaRejectionRespondSave();
    }, mounted);
    hideDialog();
  };

  const hideDialog = () => {
    setCurrentRejection(null);
    setDialogVisible(false);
  };

  if (isFetching) {
    return <MSpinner />;
  } else {
    return (
      <div className="qa-rejections">
        <QaRejectionList
          enabled={currentRejection === null}
          viewOnly={false}
          qaAppraisalRejections={appraisalQaRejections}
          onRejectionClicked={onRejectionSelected} />
        <QaRejectionRespond
          visible={dialogVisible}
          enableReinitialize={true}
          initialValues={currentRejection}
          onSave={respondToRejection}
          onCancel={hideDialog} />
      </div>
    );
  }
}

QaRejectionsWithResponse.propTypes = {
  controlNumber: PropTypes.number.isRequired, //This is needed to get the QA rejections
  onQaRejectionRespondSave: PropTypes.func.isRequired, // Update function passed down from McaseView which will update the case actions tab if its open and in view when QaRejectionResponse is saved
};